import React, { useContext } from "react";
import { MenuContext } from "../MenuManager";
import { Facebook, Instagram, Youtube, Dribbble, Twitch } from "react-feather";
import { Link, useHistory, useLocation } from 'react-router-dom';
import classNames from "classnames";

import "./style.scss";
import ConfigData from '../../../config.json';

const externalLinks = [
  {
    url: "https://www.facebook.com/GihanTharangaBandara/",
    component: <Facebook />,
  },
  {
    url: "/",
    component: <Instagram />,
  },
  {
    url: "/",
    component: <Youtube />,
  },
  {
    url: "/",
    component: <Dribbble />,
  },
  {
    url: "/",
    component: <Twitch />,
  },
];

const MenuContent = () => {
  const history = useHistory();
  const location = useLocation();
  const handleRoutes = path => {
    history.push({ pathname: path, search: location.search });
  };
  const { open } = useContext(MenuContext);
  const year = new Date().getFullYear();
  return (
    <div className="menu-holder">
      <div className={classNames("menu-inside", { open })}>
        <div className="menu-nav-container">
          <ul className="internal-nav-links">
            {ConfigData.internalLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} onClick={() => handleRoutes(link.path)}>{link.component}</Link>
                <img src={link.img} alt={''}/>
              </li>
            ))}
          </ul>
          <ul className="external-nav-links">
            {externalLinks.map((link) => (
              <li key={link.url}>
                <a target={'_blank'} href={link.url} rel="noreferrer">{link.component}</a>
              </li>
            ))}
          </ul>
          <ul>
            <li><span className={'copyright'} style={{ fontSize: 10 }}>{year} All Right Reserved Gihan Graphics</span></li>
            <li><span className={'copyright'} style={{ fontSize: 10 }}>Solution by <a rel="noreferrer" target={'_blank'} href={'https://rabbitdevs.com'}>RabbitDevs</a></span></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MenuContent;